import type { EventStatus } from "@/types/database";

export const EVENT_STATUSES: EventStatus[] = [
  "Project",
  "First Contact",
  "Documents Sent",
  "Validated",
  "Final Organization",
  "Completed",
  "Abandoned",
];

export const EVENT_STATUS_LABELS: Record<EventStatus, string> = {
  Project: "Projet",
  "First Contact": "Premier contact",
  "Documents Sent": "Documents envoyés",
  Validated: "Validé",
  "Final Organization": "Organisation finale",
  Completed: "Terminé",
  Abandoned: "Abandonné",
};

export const EVENT_STATUS_COLORS: Record<EventStatus, string> = {
  Project: "bg-gray-500",
  "First Contact": "bg-amber-700",
  "Documents Sent": "bg-orange-500",
  Validated: "bg-green-500",
  "Final Organization": "bg-blue-500",
  Completed: "bg-green-800",
  Abandoned: "bg-gray-400",
};

export const EVENT_STATUS_BADGE_VARIANTS: Record<
  EventStatus,
  | "project"
  | "first-contact"
  | "documents-sent"
  | "validated"
  | "final-org"
  | "completed"
  | "abandoned"
> = {
  Project: "project",
  "First Contact": "first-contact",
  "Documents Sent": "documents-sent",
  Validated: "validated",
  "Final Organization": "final-org",
  Completed: "completed",
  Abandoned: "abandoned",
};

export const EVENT_STATUS_DESCRIPTIONS: Record<EventStatus, string> = {
  Project: "Événement en phase de réflexion, pas encore de contact établi",
  "First Contact":
    "Premier échange avec l'organisateur, discussion des besoins",
  "Documents Sent":
    "Devis et fiche technique envoyés, en attente de validation",
  Validated: "Devis signé et acompte reçu - Événement confirmé",
  "Final Organization": "Derniers préparatifs en cours, événement imminent",
  Completed: "Événement terminé avec succès",
  Abandoned: "Événement annulé ou abandonné",
};

export const EVENT_TYPES = [
  "Louange / Adoration",
  "Évangélisation",
  "Messe",
  "Festival",
  "Concert",
  "Retraite",
  "Conférence",
  "Autre",
];

export const ORGANIZER_CATEGORIES = [
  "Diocèse",
  "Paroisse",
  "Association",
  "Festival",
  "Institution",
] as const;

export const TEAM_CATEGORIES = [
  "Beatitude Family 1",
  "Beatitude Family 2",
  "Beatitude Family 3",
  "Professional Group",
  "Mixed",
] as const;

export const MEMBER_ROLES = [
  "Responsable",
  "Musicien Directeur (MD)",
  "Coordinateur",
  "Lead",
  "Co-Lead",
  "Chant Meneur",
  "Chant Harmonies",
  "Musicien",
  "Instru Lead",
  "Technicien Son",
  "Technicien Lumière",
] as const;

export const INSTRUMENTS = [
  "Piano",
  "Basse",
  "Batterie",
  "Percussion",
  "Cajon",
  "Violon",
  "Guitare",
  "Voix",
  "Voix Soprano",
  "Voix Alto",
  "Voix Ténor",
  "Voix Basse",
  "Son",
  "Lumière",
  "Autre",
] as const;
